import { currencySymbol } from '../lib/format';
import { formatKurus } from '../lib/format';
import { t } from '@bia-auction/shared-i18n';

/**
 * A money figure, or the masked placeholder for a logged-out visitor (M11, ADR 0025).
 *
 * The masking happened **server-side** — the API sends `null` with `priceMasked: true`, so
 * there is no real number in the page to reveal. This renders the legacy site's shape
 * (`x.xxx,xx ₺`), which reads as "hidden" rather than as a price of zero, and carries a title
 * saying why.
 *
 * One component so masking cannot end up half-applied: every price on a bidder surface goes
 * through here.
 */
export function MaskedPrice({
  amount,
  masked,
  currency = 'TRY',
  className,
}: {
  amount: number | null;
  masked: boolean;
  currency?: string;
  className?: string;
}) {
  if (masked || amount === null) {
    return (
      <span className={className} title={t('bidder.masked.title')}>
        <span aria-hidden>{`x.xxx,xx ${currencySymbol(currency)}`}</span>
        <span className="sr-only">{t('bidder.masked.title')}</span>
      </span>
    );
  }
  return <span className={className}>{formatKurus(amount, currency)}</span>;
}
